import _implicitStylesheets from "./container.css";
import _implicitScopedStylesheets from "./container.scoped.css?scoped=true";
import _analyticsGtmNoScript from "analytics/gtmNoScript";
import _aceTbid from "ace/tbid";
import _aceConfirm from "ace/confirm";
import _aceHeaderWrapper from "ace/headerWrapper";
import _aceAgentforceChat from "ace/agentforceChat";
import _aceFooter from "ace/footer";
import _analyticsHandler from "analytics/handler";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"} class="skip-link${0}"${2}>${"t1"}</a>`;
const stc0 = {
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = {
  classMap: {
    "page-container": true
  },
  key: 3
};
const stc4 = {
  key: 7
};
const stc5 = {
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, fid: api_scoped_frag_id, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, fr: api_fragment, gid: api_scoped_id, ncls: api_normalize_class_name, ddc: api_deprecated_dynamic_component, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_custom_element("analytics-gtm-no-script", _analyticsGtmNoScript, stc0), api_custom_element("analytics-handler", _analyticsHandler, stc1, [api_custom_element("ace-tbid", _aceTbid, stc2), api_element("div", stc3, [$cmp.showHeaderFooter ? api_fragment(4, [api_static_fragment($fragment1, 6, [api_static_part(0, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleSkipToMain))
    },
    attrs: {
      "href": api_scoped_frag_id("#main-content")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.skipToMainContent))])], 0) : null, api_custom_element("ace-confirm", _aceConfirm, stc4), $cmp.showHeaderFooter ? api_fragment(8, [api_custom_element("ace-header-wrapper", _aceHeaderWrapper, {
    key: 9,
    on: {
      "mobilenavigationchange": _m2 || ($ctx._m2 = api_bind($cmp.handleMobileNavigationChange))
    }
  })], 0) : null, api_element("main", {
    className: api_normalize_class_name($cmp.rootContainerCss),
    attrs: {
      "id": api_scoped_id("main-content"),
      "tabindex": "-1",
      "inert": $cmp.mobileNavigationInert
    },
    ref: "mainContent",
    key: 10
  }, [api_deprecated_dynamic_component("x-lazy", $cmp.pageComponent, {
    key: 11,
    on: {
      "filterdrawerchange": _m3 || ($ctx._m3 = api_bind($cmp.handleFilterDrawerVisibilityChange))
    }
  })]), $cmp.showAgentforceChat ? api_custom_element("ace-agentforce-chat", _aceAgentforceChat, stc5) : null, $cmp.showHeaderFooter ? api_fragment(13, [api_custom_element("ace-footer", _aceFooter, {
    className: api_normalize_class_name($cmp.footerClass),
    key: 14
  })], 0) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.hasRefs = true;
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5pkbgumkf6d";
tmpl.legacyStylesheetToken = "undefined-_container";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
